// selectedGroupSlice.js
import { createSlice } from "@reduxjs/toolkit";

const selectedGroupSlice = createSlice({
  name: "selectedGroup",
  initialState: null,
  reducers: {
    setSelectedGroup: (state, action) => {
      return action.payload;
    },
  },
});

export const { setSelectedGroup } = selectedGroupSlice.actions;
export default selectedGroupSlice.reducer;
